export const ANALYTICS_NEXT_UMD_VERSION = process.env.NEXT_PUBLIC_ANALYTICS_NEXT_UMD_VERSION ?? '1.81.1';
export const ANALYTICS_NEXT_UMD_ORIGIN = 'https://cdn.jsdelivr.net';
export const ANALYTICS_NEXT_UMD_URL = `https://cdn.jsdelivr.net/npm/@segment/analytics-next@${ANALYTICS_NEXT_UMD_VERSION}/dist/umd/index.js`;
export const SEGMENT_UMD_SCRIPT_ID = 'segment-analytics-next-umd';
export const SEGMENT_BOOTSTRAP_SCRIPT_ID = 'segment-bootstrap';
export const SEGMENT_BOOTSTRAP_LISTENER_ATTRIBUTE = 'data-segment-bootstrap-listener';
export const SEGMENT_LOAD_IDLE_TIMEOUT_MS = 2000;

const segmentBootstrapWarningFn = `function logSegmentBootstrapWarning(reason){try{if(typeof console!=="undefined"&&console.warn)console.warn("[segment-early]",reason&&reason.message?reason.message:reason);}catch(_logErr){}}`;

export function buildInlineSegmentBootstrap(segmentKey: string) {
  return `
(function(){
  ${segmentBootstrapWarningFn}
  try{
    if(typeof window==="undefined"||typeof document==="undefined"||!document.head)return;
    window.__SEGMENT_WRITE_KEY__=${JSON.stringify(segmentKey)};

    function ensureSegmentScript(){
      var existingScript=document.getElementById(${JSON.stringify(SEGMENT_UMD_SCRIPT_ID)});
      if(existingScript)return existingScript;

      var createdScript=document.createElement("script");
      createdScript.async=true;
      createdScript.crossOrigin="anonymous";
      createdScript.id=${JSON.stringify(SEGMENT_UMD_SCRIPT_ID)};
      createdScript.src=${JSON.stringify(ANALYTICS_NEXT_UMD_URL)};
      document.head.appendChild(createdScript);

      return createdScript;
    }

    function bootstrapSegment(){
      try{
        var AnalyticsNext=window.AnalyticsNext;
        if(!AnalyticsNext||!AnalyticsNext.AnalyticsBrowser||!window.__SEGMENT_WRITE_KEY__)return false;
        var existing=window.analytics;
        if(!existing||typeof existing.user!=="function"){
          try{
            window.analytics=AnalyticsNext.AnalyticsBrowser.load({writeKey:window.__SEGMENT_WRITE_KEY__});
          }catch(loadError){
            logSegmentBootstrapWarning(loadError);
            return true;
          }
        }
        if(window.analytics&&typeof window.analytics.then==="function"){
          window.analytics.then(undefined,logSegmentBootstrapWarning);
        }
        return true;
      }catch(bootstrapError){
        logSegmentBootstrapWarning(bootstrapError);
        return true;
      }
    }

    function loadSegment(){
      // If the app's bundled tracking path (TrackingManager) already set up analytics,
      // don't fetch the redundant CDN UMD at all.
      var existing=window.analytics;
      if(existing&&typeof existing.user==="function")return;
      if(bootstrapSegment())return;

      var segmentScript=ensureSegmentScript();
      if(segmentScript.getAttribute(${JSON.stringify(SEGMENT_BOOTSTRAP_LISTENER_ATTRIBUTE)})==="true")return;

      segmentScript.setAttribute(${JSON.stringify(SEGMENT_BOOTSTRAP_LISTENER_ATTRIBUTE)},"true");
      segmentScript.addEventListener("load",bootstrapSegment,{once:true});
      segmentScript.addEventListener("error",function(){try{logSegmentBootstrapWarning("segment-umd-load-failed");}catch(_onErr){}},{once:true});
    }

    // If the UMD is already present (e.g. a cached duplicate), bootstrap synchronously.
    if(bootstrapSegment())return;

    // Do not listen for "scroll": history scroll-restoration fires it on reload / back-forward
    // and would start the load during the initial window.
    var segmentLoadStarted=false;
    var interactionEvents=["pointerdown","keydown","touchstart"];
    var idleFallbackTimer=null;
    function startSegmentLoad(){
      if(segmentLoadStarted)return;
      segmentLoadStarted=true;
      for(var i=0;i<interactionEvents.length;i++){
        try{window.removeEventListener(interactionEvents[i],startSegmentLoad);}catch(_removeErr){}
      }
      if(idleFallbackTimer){try{clearTimeout(idleFallbackTimer);}catch(_clearErr){}idleFallbackTimer=null;}
      loadSegment();
    }
    for(var e=0;e<interactionEvents.length;e++){
      try{window.addEventListener(interactionEvents[e],startSegmentLoad,{passive:true});}catch(_addErr){}
    }
    if(typeof window.requestIdleCallback==="function"){
      window.requestIdleCallback(startSegmentLoad,{timeout:${SEGMENT_LOAD_IDLE_TIMEOUT_MS}});
    }else{
      idleFallbackTimer=setTimeout(startSegmentLoad,${SEGMENT_LOAD_IDLE_TIMEOUT_MS});
    }
  }catch(outerErr){logSegmentBootstrapWarning(outerErr);}
})();
`.trim();
}
